import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    ORGANISATION_SETTING_PATCH_FAILURE: "ORGANISATION_SETTING_PATCH_FAILURE",
    ORGANISATION_SETTING_PATCH_REQUEST: "ORGANISATION_SETTING_PATCH_REQUEST",
    ORGANISATION_SETTING_PATCH_SUCCESS: "ORGANISATION_SETTING_PATCH_SUCCESS"
};

export const actionCreators = {
    patchRequest: (settingId: any, data: any) => ({
        type: actionTypes.ORGANISATION_SETTING_PATCH_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.ORGANISATION_SETTING_PATCH_SUCCESS,
        [ERROR_ACTION]: actionTypes.ORGANISATION_SETTING_PATCH_FAILURE,
        payload: { settingId, data }
    }),
    patchSuccess: (data: any) => ({
        type: actionTypes.ORGANISATION_SETTING_PATCH_SUCCESS,
        payload: { data }
    }),
    patchFailure: (error: Error) => ({
        type: actionTypes.ORGANISATION_SETTING_PATCH_FAILURE,
        error
    })
};

export default {
    create: actionCreators,
    type: actionTypes
};
